module.exports = __webpack_public_path__ + "static/media/santa_katarina_thumb_even.049d1319.webp";